import '../components/AuthModal';
import '../components/AppHeader';
import '../components/CreateChannelModal';
import '../components/SearchBar';
import '../components/AuthProvider';
import AppAnalytics from '../client/AnalyticsClient';

window.addEventListener('DOMContentLoaded', () => {
  AppAnalytics.getPlausible()
});

